module.exports = __webpack_public_path__ + "static/1-70fba97cc503ff9d6443623ea97b6a78.jpg";